var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.616 19.77C7.15533 19.77 6.771 19.616 6.463 19.308C6.155 19 6.00067 18.6153 6 18.154V5.77H5V4.77H9V4H15V4.77H19V5.77H18V18.155C18 18.615 17.846 18.9993 17.538 19.308C17.23 19.6167 16.8453 19.7707 16.384 19.77H7.616ZM9.808 16.77H10.808V7.77H9.808V16.77ZM13.192 16.77H14.192V7.77H13.192V16.77Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDel);
export default __webpack_public_path__ + "static/media/serverDel.dd3bc76953f7185fdb885b5d4f8a14b6.svg";
export { ForwardRef as ReactComponent };